<template>
  <div id="ullist">
    <ul class="ullist_first">
      <li class="lishove" v-for="(item, index) in datalist" :key="index">
        <div
          class="jt_right"
          @mouseover="
            () =>
              liHover(
                isBolts(item) ? 'standardByGroup' : 'standardByCategory' //紧固件 三级默认按标准，非紧固件 没有标准，只能按分类
              )
          "
          @click="jumpGoods(item)"
        >
          <img class="test_img" :src="item.categoryIcon || defaultimg" />
          <div class="span_style">
            {{ item.categoryName }}
          </div>
          <div>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
        <div class="item_content">
          <ul v-if="false">
            <!-- v-if="item.level2 && item.level2.length" -->
            <!-- 有level2 不是紧固件 -->
            <li>
              <div class="div_text div_text_header">所有类别</div>
            </li>
            <li v-for="(items, indexs) in item.level2" :key="indexs">
              <div class="div_text" @click="jumpGoods(items)">
                {{ items.categoryName }}
                <div class="list_img">
                  <div class="new-ul">
                    <div
                      v-for="(ite3, ind3) in items.level3"
                      :key="ind3"
                      class="list_img_li"
                    >
                      <img :src="ite3.categoryIcon || defaultimg" />
                      <div class="text_style">{{ ite3.categoryName }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <div v-else class="JinGuJian_content">
            <!--  是紧固件 -->
            <div class="JinGuJian_title">
              <div
                v-if="isBolts(item)"
                :class="
                  activeName === 'standardByGroup'
                    ? 'active_text'
                    : 'unActive_text'
                "
                @mouseover="() => liHover('standardByGroup')"
              >
                按标准
              </div>
              <div
                :class="
                  activeName === 'standardByCategory'
                    ? 'active_text'
                    : 'unActive_text'
                "
                @mouseover="() => liHover('standardByCategory')"
              >
                按分类
              </div>
            </div>
            <div class="new-text">
              <div
                class="new-name"
                v-for="(value, keyName, ind3) of showAttribute(
                  item.attribute,
                  activeName,
                  item
                )"
                :key="ind3"
              >
                <div
                  @click="jump(value, isBolts(item))"
                  class="text_style JinGuJian_text"
                >
                  {{ isBolts(item) ? keyName : value.categoryName }}：
                </div>
                <div class="text_style_show">
                  <div
                    class="show_text"
                    v-for="(ite3, ind4) in isBolts(item) ? value : value.level3"
                    :key="ind4"
                    @click="
                      jumpGoods(ite3, isBolts(item) ? item.categoryId : '')
                    "
                  >
                    {{
                      isBolts(item)
                        ? keyName === '非标'
                          ? ite3.categoryName
                          : ite3.standardNo
                        : ite3.categoryName
                    }}
                  </div>
                </div>
              </div>

              <el-empty
                v-if="
                  showAttribute(item.attribute, activeName, item).length === 0
                "
                description="暂无数据"
              ></el-empty>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import {
  getTopCategory,
  getAllMainCategory,
  getProductCategoryStandardInfo
} from "@/api/category";
import store from "@/vuex/store";
export default {
  name: "ullist",
  data () {
    return {
      datalist: [],
      defaultimg: require("../../../assets/no-picture.png"),
      activeName: "standardByGroup",    //standardByCategory,standardByGroup
    };
  },
  methods: {
    jump (item, ok) {
      !ok && this.jumpGoods(item)
    },
    isBolts (item) {
      return !(item.level2 && item.level2.length) //判断是否是紧固件
    },
    showAttribute (attribute, activeName, item) {
      if (this.isBolts(item)) {
        // 紧固件
        return attribute ? attribute[activeName] : []
      } else {
        //非紧固件
        return item.level2
      }
    },
    liHover (flag) {
      this.activeName = flag;
    },
    //点击跳转
    jumpGoods (item, id) {
      this.$emit('click.stop') // 阻止事件冒泡
      let routeUrl = this.$router.resolve({
        path: "/GoodsList",
        query: { id: item.categoryId, level: item.categoryLevel, type: "1" }
      });
      if (item.standardNo && id) {
        routeUrl = this.$router.resolve({
          path: "/GoodsList",
          query: {
            id: id,
            level: 3,
            type: "1",
            NO: item.standardNo,
            attId: item.attributeId
          }
        });
      }
      window.open(routeUrl.href, "_self");
      // window.open(routeUrl.href, "_blank");
    },
    getTopCategory () {
      getTopCategory().then(res => {
        if (res.data.code == 200) {
          this.datalist = res.data.data;
          this.getAllMainCategory();
        }
      });
    },
    async getAllMainCategory () {
      await getAllMainCategory().then(res => {
        if (res.data.code == 200) {
          let arrGoods = res.data.data || [];
          this.datalist.forEach(a => {
            let obj = arrGoods.find(b => b.categoryId === a.categoryId);
            if (obj) {
              this.$set(a, 'level2', obj.level2)
            }
          })
        }
      });
      let JinGuJian = this.datalist.find(i => i.categoryName === "紧固件");
      if (JinGuJian) {
        store.commit("GET_CATEGORY", JinGuJian);
      }
      // let id = JinGuJian.categoryId;
      getProductCategoryStandardInfo().then(res => {
        if (res.data.code == 200) {
          let arrGoods = res.data.data || [];
          this.datalist.forEach(a => {
            arrGoods.map(b => {
              if (b.productCategoryDto.id === a.categoryId) {
                this.$set(a, 'attribute', b);
              }
            });
          })
        }
      });
    }
  },
  created () {
    this.getTopCategory();
  }
};
</script>

<style scoped lang="scss">
#ullist {
  z-index: 99999;
  width: 235px;
  height: 430px;
  background: #fff;
  position: relative;
  border-radius: 0px;
  .ullist_first {
    border: 1px solid #e6e6e6;
    height: 100%;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
    overflow-y: auto;
    li {
      font-size: 16px;
      line-height: 40px;
      display: flex;
      justify-content: space-between;
      padding: 0 10px;
      box-sizing: border-box;
      .jt_right {
        width: 210px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        .test_img {
          width: 18px;
          height: 18px;
          position: relative;
          top: 2px;
          margin-right: 12px;
          margin-top: 14px;
        }
        // span {
        //   margin: 0 2px;
        //   cursor: initial;
        // }
        .span_style {
          text-align: left;
          width: 170px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .span_style:hover {
          text-decoration: underline;
        }
      }
      .item_content {
        height: 100%;
        background: #fff;
        position: absolute;
        left: 233px;
        top: 0px;
        display: none;
        ul {
          width: 180px;
          height: 100%;
          display: flex;
          flex-direction: column;
          overflow: auto;
          background: #f5f5f5;
          li {
            padding: 0;
            display: flex;
            flex-direction: column;
            .div_text_header {
              color: #fe9f43;
            }
            .div_text {
              text-align: left;
              cursor: pointer;
              padding: 0 10px;
              box-sizing: border-box;
              .list_img {
                display: none;
                width: 741px;
                padding: 15px;
                height: 100%;
                background: #fff;
                position: absolute;
                top: 0;
                left: 176px;
                flex-wrap: wrap;
                align-content: flex-start; //取消因为换行造成的间距过大
                justify-content: initial;
                align-items: initial;
                overflow: auto;
                box-sizing: border-box;

                .new-ul {
                  background: white;
                  display: flex;
                  flex-flow: row wrap;
                  $color: #fe7410;
                  .list_img_li {
                    color: #000000;
                    width: 76px;
                    margin: 6px;
                    font-size: 14px;
                    line-height: initial;
                    text-align: center;
                    img {
                      width: 90%;
                      margin-bottom: 10px;
                      box-sizing: border-box;
                    }
                    .text_style {
                      display: -webkit-box;
                      -webkit-box-orient: vertical;
                      -webkit-line-clamp: 1; /*超出几行后省略号*/
                      overflow: hidden;
                    }
                  }
                  .list_img_li:hover {
                    img {
                      border: 1px solid #ff6900;
                      box-sizing: border-box;
                    }
                  }
                }
                &::-webkit-scrollbar {
                  width: 5px;
                }
                &::-webkit-scrollbar-thumb {
                  background: #d8d8d8;
                  border-radius: 10px;
                }
                &::-webkit-scrollbar-track-piece {
                  background: transparent;
                }
                .list_img_li {
                  color: #000000;
                  width: 76px;
                  margin: 7px;
                  font-size: 14px;
                  line-height: initial;
                  text-align: center;
                  img {
                    width: 90%;
                    margin-bottom: 10px;
                    box-sizing: border-box;
                  }
                  .text_style {
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1; /*超出几行后省略号*/
                    overflow: hidden;
                  }
                }
                .list_img_li:hover {
                  img {
                    border: 1px solid #ff6900;
                    box-sizing: border-box;
                  }
                }
              }
            }
            .div_text:hover {
              background: #facd91;
              color: #fe7410;
              .list_img {
                display: flex;
              }
            }
          }
        }
        ul::-webkit-scrollbar {
          width: 4px;
          background: #cac8c8;
        }
        /*定义滑块 样式*/
        ul::-webkit-scrollbar-thumb {
          border-radius: 3px;
          background-color: #a8a8a8;
        }
        .JinGuJian_content {
          background: #f5f5f5;
          width: 917px;
          height: 100%;
          overflow: auto;
          .JinGuJian_title {
            display: flex;
            text-align: left;
            padding-left: 15px;
            div {
              font-size: 16px;
              width: 80px;
              text-align: center;
            }
            .active_text {
              border-bottom: 1px solid red;
              color: red;
            }
            .unActive_text {
              border-bottom: 1px solid black;
              color: black;
            }
          }
          .new-text {
            background: #f5f5f5;
            height: 373px;
            position: absolute;
            top: 56px;
            left: 0px;
            width: 100%;
            padding-left: 15px;
            flex-wrap: wrap;
            align-content: flex-start; //取消因为换行造成的间距过大
            justify-content: initial;
            align-items: initial;
            overflow: auto;
            box-sizing: border-box;
            .new-name {
              padding: 10px 0;
              .JinGuJian_text {
                text-align: left;
                color: #fe7410;
              }
              .text_style {
                font-size: 16px;
              }
              .text_style_show {
                font-size: 12px;
                color: #000000;
                line-height: 20px;
                display: flex;
                flex-wrap: wrap;
                .show_text {
                  padding: 0px 20px 0 0;
                }
                .show_text:hover {
                  color: #fe7410;
                }
              }
            }
            &::-webkit-scrollbar {
              width: 5px;
            }
            &::-webkit-scrollbar-thumb {
              background: #d8d8d8;
              border-radius: 10px;
            }
            &::-webkit-scrollbar-track-piece {
              background: transparent;
            }
          }
        }
      }
    }
    .lishove {
      height: 50px;
      line-height: 50px;
      &:hover {
        // background: #ff6920;
        cursor: pointer;
        color: #ff6920;
        .item_content {
          display: initial;
          color: #000000;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/ProductBrowser.vue